/* tslint:disable */

declare var Object: any;
export interface ERPinternalInventoryRequisitionInterface {
  "id"?: number;
}

export class ERPinternalInventoryRequisition implements ERPinternalInventoryRequisitionInterface {
  "id": number;
  constructor(data?: ERPinternalInventoryRequisitionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPinternalInventoryRequisition`.
   */
  public static getModelName() {
    return "ERPinternalInventoryRequisition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPinternalInventoryRequisition for dynamic purposes.
  **/
  public static factory(data: ERPinternalInventoryRequisitionInterface): ERPinternalInventoryRequisition{
    return new ERPinternalInventoryRequisition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPinternalInventoryRequisition',
      plural: 'ERPinternalInventoryRequisitions',
      path: 'ERPinternalInventoryRequisitions',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPinternalInventoryRequisition.ts